<template>
  <CFooter :fixed="false">
    <div>
      <span class="ml-1">병해충 영상진단 - Cloud Web Application Framework &copy; 2021</span>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>
